module.exports = __webpack_public_path__ + "img/volver-figura.d705c58f.svg";